import React from 'react'
import { Typography, Link } from 'transfix-ui/core'

export interface IEdiWarningMessage {
  onReview: () => void
}

export const EdiWarningMessage = ({ onReview }: IEdiWarningMessage) => {
  return (
    <div>
      <Typography variant='body2'>New duplicate facility address needs reviewing</Typography>
      <Link onClick={onReview}>Review</Link>
    </div>
  )
}
